import Box from "@mui/material/Box";
import GalleryItem from "../Gallery/GalleryItem";
import {
  acceptedFormatsPreview,
  buildAdMediaGalleryItem,
  getValidMediaUrls,
} from "./adMediaPreviewUtils";

//eslint-disable-next-line
export const adMediaPreviewTooltipSlotProps = {
  tooltip: {
    sx: {
      backgroundColor: "#FFFFFF",
      color: "text.primary",
      p: 0,
      maxWidth: "unset",
      borderRadius: 3,
      border: "1px solid #E5E5E5",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.18)",
      overflow: "hidden",
    },
  },
  arrow: {
    sx: {
      color: "#FFFFFF",
    },
  },
};

const sxTooltipContainer = {
  width: 280,
  maxWidth: 280,
  p: 1,
};

const onNoop = () => {};

const AdMediaPreviewTooltipContent = ({ mediaUrls = [] }) => {
  const validUrls = getValidMediaUrls(mediaUrls);
  const galleryItem = buildAdMediaGalleryItem(validUrls);
  const isCarouselPreview = validUrls.length > 1;

  if (!galleryItem) {
    return null;
  }

  return (
    <Box
      sx={{
        ...sxTooltipContainer,
        pb: isCarouselPreview ? 1.5 : sxTooltipContainer.p,
      }}
    >
      <GalleryItem
        item={galleryItem}
        index={0}
        multiple={false}
        isSelected={false}
        showActionButtons={false}
        showDeleteButton={false}
        showDimensionsOverlay={false}
        showResizeFormatButton={false}
        overlayPickerMode={false}
        acceptedFormats={acceptedFormatsPreview}
        onSelectItem={onNoop}
        onSelectPreview={onNoop}
        onDeleteItem={onNoop}
        onDownloadItems={onNoop}
        onFailedLoadUrl={onNoop}
      />
    </Box>
  );
};

export default AdMediaPreviewTooltipContent;
